import PropTypes from 'prop-types';
import { Sun } from 'lucide-react';
import { matchesZone, sunlightPreferenceText } from '../../../utils/sunlightMatch';
import { SUN_ZONES } from '../../../scene3d/shadow/shadowZones';

/**
 * SunlightWarningBadge - ruhiger Licht-Abgleich (#606)
 *
 * Zeigt einen Hinweis, wenn die für die Pflanzposition berechnete Lichtzone
 * (Jahresübersicht) nicht zum Lichtbedarf der Pflanze passt. Analog
 * HardinessWarningBadge: Orientierungshilfe, keine Alarm-Mechanik — kein
 * Zwang, keine Ausrufezeichen, kein Blockieren. Rendert nichts, wenn es passt
 * oder keine Zone/kein Lichtbedarf vorliegt.
 *
 * @param {'full'|'partial'|'shade'|null} zone - berechnete Zone an der Position
 * @param {string|string[]} sunlight - Lichtbedarf der Pflanze (Enum/Liste)
 */
const SunlightWarningBadge = ({ zone, sunlight }) => {
  if (matchesZone(zone, sunlight) !== 'mismatch') return null;

  const zoneLabel = SUN_ZONES[zone]?.label ?? '';
  const prefText = sunlightPreferenceText(sunlight);

  return (
    <div
      className="flex items-start gap-3 p-4 rounded-lg border bg-amber-50 border-amber-200"
      role="status"
      aria-label={`Lichtbedarf: Standort ${zoneLabel}, bevorzugt ${prefText}`}
    >
      <Sun className="w-5 h-5 flex-shrink-0 mt-0.5 text-amber-600" aria-hidden="true" />
      <div>
        <div className="text-sm font-bold mb-1 text-amber-900">Licht passt nicht ganz</div>
        <p className="text-sm leading-relaxed text-amber-800">
          Diese Stelle ist nach der Jahresübersicht {zoneLabel.toLowerCase()}. Die
          Pflanze bevorzugt {prefText}. Ein Standortwechsel kann ihr guttun — ein
          Muss ist es nicht.
        </p>
      </div>
    </div>
  );
};

SunlightWarningBadge.propTypes = {
  zone: PropTypes.oneOf(['full', 'partial', 'shade', null]),
  sunlight: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default SunlightWarningBadge;
